/* eslint-disable prefer-destructuring */
import { connect } from 'react-redux';

import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    SearchItemContainer as SourceSearchItemContainer
} from 'SourceComponent/SearchItem/SearchItem.container';

/** @namespace Elganso/Component/SearchItem/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
    // TODO extend mapDispatchToProps
});

/** @namespace Elganso/Component/SearchItem/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
    // TODO extend mapStateToProps
});

/** @namespace Elganso/Component/SearchItem/Container */
export class SearchItemContainer extends SourceSearchItemContainer {
    getImgSrc() {
        const { product } = this.props;

        let url = '';

        if (product.thumbnail) {
            url = product.thumbnail.url;
        } else if (product.image) {
            url = product.image.url;
        }

        return url;
    }

    // YB Aqui podemos cambiar url por url_rewrites pero este no incluye store(es)
    getLinkTo() {
        const {
            product,
            product: { url }
        } = this.props;

        if (url && url.includes('catalog/product/view/id')) {
            if (product?.url_rewrites && product.url_rewrites.length > 0) {
                // const storeId = getStore().getState().ConfigReducer.code;
                const rewritesUrl = String(product.url_rewrites[0].url);
                return {
                    pathname: rewritesUrl,
                    state: { product }
                };
            }
        }

        if (!url) {
            return {};
        }

        return {
            pathname: url,
            state: { product }
        };
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchItemContainer);
